import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogWrapper } from '@common/components/modal/dialog-wrapper';
import CourseOptionCard from '../../components/course-option-card';
import Permission from '@common/components/permission';
import { EPermissions } from '@common/definitions';
import { useParams } from 'react-router';
import { ECourseTypes } from '@modules/learning/definitions';

type AIModuleFormProps = {
  onOpenCourse: (id: string) => void;
  children: React.ReactNode;
};

const AIModuleForm = memo(({ onOpenCourse, children }: AIModuleFormProps) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const params = useParams<{ type: ECourseTypes }>();

  const handleHide = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  const handleManualCreate = () => {
    onOpenCourse('manual');
    handleHide();
  };

  const handleGenAiCreate = () => {
    onOpenCourse('genai');
    handleHide();
  };

  return (
    <DialogWrapper
      trigger={children}
      show={show}
      onHide={handleHide}
      onShow={handleShow}
      size="small"
      title="New course"
      hideFooter
      content={
        <div className="tw-flex tw-flex-col tw-gap-4">
          <Permission
            name={
              params.type === ECourseTypes.ONBOARDING
                ? EPermissions.ORGANISATION_ONBOARDING_COURSES_CREATE
                : EPermissions.ORGANISATION_ACADEMY_COURSES_CREATE
            }
          >
            <CourseOptionCard
              title={t('learning:onboarding_manually_create_course')}
              description={t('learning:onboarding_manually_create_course_desc')}
              iconUrl="/static/images/create-course.png"
              onClick={handleManualCreate}
            />
          </Permission>
          <CourseOptionCard
            title={t('learning:onboarding_create_course_using_ai')}
            description={t('learning:onboarding_create_course_using_ai_desc')}
            iconUrl="/static/images/gen-ai-course.png"
            onClick={handleGenAiCreate}
          />
        </div>
      }
    />
  );
});

export default AIModuleForm;
